export const fonts = {
  heading:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  body:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  mono:
    'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace',
}

export const fontSizes = [
  12,
  14,
  16,
  18,
  20,
  24,
  28,
  32,
  40,
  48,
  56,
  64,
  80,
  96,
]

fontSizes['xs'] = '0.75rem'
fontSizes['sm'] = '0.875rem'
fontSizes['md'] = '1rem'
fontSizes['lg'] = '1.125rem'
fontSizes['xl'] = '1.25rem'
fontSizes['2xl'] = '1.5rem'
fontSizes['3xl'] = '1.875rem'
fontSizes['4xl'] = '2.25rem'
fontSizes['5xl'] = '3rem'
fontSizes['6xl'] = '4rem'

export const fontWeights = {
  body: 400,
  heading: 700,

  hairline: 100,
  thin: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900,
}

export const letterSpacings = {
  tighter: '-0.05em',
  tight: '-0.025em',
  normal: '0',
  wide: '0.025em',
  wider: '0.05em',
  widest: '0.1em',
}

export const lineHeights = {
  body: 1.5,
  heading: 1.25,

  none: 1,
  shorter: 1.25,
  short: 1.375,
  base: 1.5,
  tall: 1.625,
  taller: 2,
}
